import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.includes.js";
import { defineStore } from 'pinia';
export var OrganizerSignupStep = /*#__PURE__*/function (OrganizerSignupStep) {
  OrganizerSignupStep[OrganizerSignupStep["EventDetails"] = 0] = "EventDetails";
  OrganizerSignupStep[OrganizerSignupStep["OrganizerDetails"] = 1] = "OrganizerDetails";
  OrganizerSignupStep[OrganizerSignupStep["PayoutDetails"] = 2] = "PayoutDetails";
  OrganizerSignupStep[OrganizerSignupStep["ContactDetails"] = 3] = "ContactDetails";
  OrganizerSignupStep[OrganizerSignupStep["ReviewDetails"] = 4] = "ReviewDetails";
  OrganizerSignupStep[OrganizerSignupStep["Finish"] = 5] = "Finish";
  return OrganizerSignupStep;
}({});
var useOrganizerSignupStoreDefinition = defineStore('organizerSignup', {
  state: function state() {
    return {
      validSteps: [],
      requestId: null,
      eventDetails: null,
      organizerDetails: null,
      payoutDetails: null,
      contactDetails: null
    };
  },
  getters: {
    getSteps: function getSteps(state) {
      return state.validSteps;
    },
    getRequestId: function getRequestId(state) {
      return state.requestId;
    },
    getEventDetails: function getEventDetails(state) {
      return state.eventDetails;
    },
    getOrganizerDetails: function getOrganizerDetails(state) {
      return state.organizerDetails;
    },
    getPayoutDetails: function getPayoutDetails(state) {
      return state.payoutDetails;
    },
    getContactDetails: function getContactDetails(state) {
      return state.contactDetails;
    }
  },
  actions: {
    addStepValid: function addStepValid(payload) {
      if (this.validSteps.includes(payload)) {
        return;
      }
      this.validSteps.push(payload);
    },
    removeStepValid: function removeStepValid(payload) {
      var index = this.validSteps.indexOf(payload);
      if (index > -1) {
        this.validSteps.splice(index, 1);
      }
    },
    setRequestId: function setRequestId(payload) {
      this.requestId = payload;
    },
    setEventDetails: function setEventDetails(payload) {
      this.eventDetails = payload;
    },
    setOrganizerDetails: function setOrganizerDetails(payload) {
      this.organizerDetails = payload;
    },
    setPayoutDetails: function setPayoutDetails(payload) {
      this.payoutDetails = payload;
    },
    setContactDetails: function setContactDetails(payload) {
      this.contactDetails = payload;
    },
    clearStoreState: function clearStoreState() {
      this.validSteps = [];
      this.requestId = null;
      this.eventDetails = null;
      this.organizerDetails = null;
      this.payoutDetails = null;
      this.contactDetails = null;
    },
    setOrganizerApplicationDetails: function setOrganizerApplicationDetails(payload) {
      this.setRequestId(payload.requestId);
      this.setEventDetails(payload.eventDetails);
      this.setOrganizerDetails(payload.organizerDetails);
      this.setPayoutDetails(payload.payoutDetails);
      this.setContactDetails(payload.contactDetails);
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useOrganizerSignupStoreDefinition directly as
// useOrganizerSignupStore instead.
export function useOrganizerSignupStore() {
  return useOrganizerSignupStoreDefinition(usePinia());
}